<app-modal [isOpen]="isOpen"
           title="{{ 'web.purchaseChoosePaymentOption' | translate }}"
           (close)="onClose()">

  @for (option of paymentOptions; track option) {
  <label class="modal-selection-item"
         [class.selected]="currentMethod === option.value"
         tabindex="0"
         (keydown.enter)="selectMethod(option.value)"
         (keydown.space)="$event.preventDefault(); selectMethod(option.value)">

    <input type="radio"
           class="radio-button"
           [checked]="currentMethod === option.value"
           tabindex="-1"
           (change)="selectMethod(option.value)"
           [name]="'paymentOption'"
           [value]="option.value"
           [attr.aria-label]="option.label | translate">

    <div class="payment-info">
      <img [src]="option.icon" [alt]="option.label" class="payment-icon">
      <span>{{ option.label | translate }}</span>
    </div>
  </label>
  }
</app-modal>
